import { useState } from 'react';
import ConsultModal from './ConsultModal';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isConsultModalOpen, setIsConsultModalOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <>
      <header className="bg-white shadow-md sticky top-0 z-40">
        <nav className="w-full px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
                <i className="ri-book-open-line text-white text-2xl"></i>
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-800">威斯理美語安親班</h1>
                <p className="text-xs text-gray-600">Wesley English Learning Center</p>
              </div>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <button
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                關於我們
              </button>
              <button
                onClick={() => scrollToSection('courses')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                課程介紹
              </button>
              <button
                onClick={() => scrollToSection('elementary')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                國小部
              </button>
              <button
                onClick={() => scrollToSection('junior-high')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                國中部
              </button>
              <button
                onClick={() => scrollToSection('senior-high')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                高中部
              </button>
              <button
                onClick={() => scrollToSection('camps')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                營隊活動
              </button>
              <button
                onClick={() => scrollToSection('charity')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                社會公益
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                聯絡我們
              </button>
            </div>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <button
                onClick={() => setIsConsultModalOpen(true)}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full font-medium hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg cursor-pointer whitespace-nowrap"
              >
                立即諮詢
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-blue-600 cursor-pointer"
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 space-y-3">
              <button
                onClick={() => scrollToSection('about')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                關於我們
              </button>
              <button
                onClick={() => scrollToSection('courses')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                課程介紹
              </button>
              <button
                onClick={() => scrollToSection('elementary')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                國小部
              </button>
              <button
                onClick={() => scrollToSection('junior-high')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                國中部
              </button>
              <button
                onClick={() => scrollToSection('senior-high')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                高中部
              </button>
              <button
                onClick={() => scrollToSection('camps')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                營隊活動
              </button>
              <button
                onClick={() => scrollToSection('charity')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                社會公益
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors cursor-pointer"
              >
                聯絡我們
              </button>
              <button
                onClick={() => {
                  setIsConsultModalOpen(true);
                  setIsMenuOpen(false);
                }}
                className="block w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-3 rounded-lg font-medium hover:from-blue-700 hover:to-purple-700 transition-all cursor-pointer whitespace-nowrap"
              >
                立即諮詢
              </button>
            </div>
          )}
        </nav>
      </header>

      <ConsultModal isOpen={isConsultModalOpen} onClose={() => setIsConsultModalOpen(false)} />
    </>
  );
}
